import { ApiResponse } from "src/types/api-response";
import { DashBoardSam, DashBoardSucKhoe, SensorDeviceModel } from "src/types/dashboardSam";
import { apiGet } from "./api-client";

export const dashboardApiService = {
    async DashBoardSam(): Promise<ApiResponse<DashBoardSam>> {
        return apiGet<ApiResponse<DashBoardSam>>(
            `/DashBoard/DashBoardSam`,
            'DashBoard',
            'Không thể tải dữ liệu dashboard'
        );
    },
    async DashBoardSucKhoe(): Promise<ApiResponse<DashBoardSucKhoe>> {
        return apiGet<ApiResponse<DashBoardSucKhoe>>(
            `/DashBoard/DashBoardSucKhoe`,
            'DashBoard',
            'Không thể tải dữ liệu dashboard'
        );
    },
    async DashBoardSensor(): Promise<ApiResponse<SensorDeviceModel>> {
        return apiGet<ApiResponse<SensorDeviceModel>>(
            `/DashBoard/DashBoardSensor`,
            'DashBoard',
            'Không thể tải dữ liệu dashboard'
        );
    }
};
